import React, { useState, useEffect } from 'react';
import { useAdminAuth } from '../context/AdminAuthContext';
import { getAdminRequests, updateRequestStatus, deleteAdminRequest } from '../api/adminApi';

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString('fa-IR', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}

const STATUS_CONFIG = {
  pending: { label: 'در انتظار', color: '#ff9800', icon: 'hourglass_empty' },
  sent: { label: 'ارسال شده', color: '#4FC3F7', icon: 'send' },
  closed: { label: 'بسته شده', color: '#90A4AE', icon: 'lock' }
};

export const AdminRequests = () => {
  const { token } = useAdminAuth();
  const [requests, setRequests] = useState([]);
  const [counts, setCounts] = useState({ pending: 0, sent: 0, closed: 0 });
  const [statusFilter, setStatusFilter] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  const [expandedId, setExpandedId] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  const loadRequests = async (status = statusFilter, pageNum = page) => {
    setLoading(true);
    const result = await getAdminRequests(token, status, pageNum);
    setLoading(false);

    if (result.success) {
      setRequests(result.data.requests);
      setTotalPages(result.data.totalPages);
      setCounts(result.data.counts);
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  useEffect(() => {
    loadRequests(statusFilter, page);
    // eslint-disable-next-line
  }, [statusFilter, page]);

  const handleFilterChange = (status) => {
    setStatusFilter(status);
    setPage(1);
  };

  const handleStatusChange = async (requestId, newStatus) => {
    const result = await updateRequestStatus(token, requestId, newStatus);

    if (result.success) {
      setToast({ show: true, type: 'success', message: result.data.message });
      loadRequests();
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  const handleDelete = async () => {
    if (!deleteTarget) return;
    const result = await deleteAdminRequest(token, deleteTarget.id);
    setDeleteTarget(null);

    if (result.success) {
      setToast({ show: true, type: 'success', message: result.data.message });
      loadRequests();
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  const tabs = [
    { key: '', label: 'همه', count: counts.pending + counts.sent + counts.closed },
    { key: 'pending', label: 'در انتظار', count: counts.pending },
    { key: 'sent', label: 'ارسال شده', count: counts.sent },
    { key: 'closed', label: 'بسته شده', count: counts.closed }
  ];

  return (
    <div dir="rtl" style={{ padding: 24 }}>
      <h2 className="w3-text-white" style={{ marginBottom: 20 }}>درخواست‌های فایل</h2>

      {/* تب‌های فیلتر وضعیت */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => handleFilterChange(tab.key)}
            className="w3-button w3-round-xxlarge"
            style={{
              backgroundColor: statusFilter === tab.key ? '#2980b9' : 'transparent',
              color: 'white',
              border: '1px solid #37474F',
              fontSize: 13,
              padding: '8px 16px'
            }}
          >
            {tab.label} ({tab.count})
          </button>
        ))}
      </div>

      <div className="w3-card-4 w3-round-large" style={{ backgroundColor: '#263238' }}>
        {loading ? (
          <p className="w3-text-grey w3-center" style={{ padding: 30 }}>در حال بارگذاری...</p>
        ) : requests.length === 0 ? (
          <p className="w3-text-grey w3-center" style={{ padding: 30 }}>درخواستی یافت نشد.</p>
        ) : (
          requests.map((req) => {
            const statusInfo = STATUS_CONFIG[req.status];
            const isExpanded = expandedId === req.id;

            return (
              <div key={req.id} style={{ borderBottom: '1px solid #37474F' }}>
                <div
                  onClick={() => setExpandedId(isExpanded ? null : req.id)}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '14px 18px',
                    cursor: 'pointer'
                  }}
                  className="w3-hover-blue-grey"
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div
                      className="w3-round"
                      style={{
                        backgroundColor: `${statusInfo.color}22`,
                        color: statusInfo.color,
                        fontSize: 11,
                        padding: '4px 10px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4
                      }}
                    >
                      <i className="material-icons" style={{ fontSize: 13 }}>{statusInfo.icon}</i>
                      {statusInfo.label}
                    </div>
                    <span className="w3-text-white" style={{ fontSize: 14 }}>
                      {req.product_type_name || 'نامشخص'} — {req.description.slice(0, 40)}{req.description.length > 40 ? '...' : ''}
                    </span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span className="w3-text-grey" style={{ fontSize: 12 }}>{formatDate(req.created_at)}</span>
                    <i className="material-icons w3-text-white">{isExpanded ? 'expand_less' : 'expand_more'}</i>
                  </div>
                </div>

                {isExpanded && (
                  <div style={{ padding: '0 18px 18px 18px', backgroundColor: '#1c2529' }}>
                    <div className="w3-row" style={{ marginBottom: 14 }}>
                      <div className="w3-col s12 m6" style={{ padding: '8px 0' }}>
                        <div className="w3-text-grey" style={{ fontSize: 12 }}>نوع فایل</div>
                        <div className="w3-text-white">{req.product_type_name || 'نامشخص'}</div>
                      </div>
                      <div className="w3-col s12 m6" style={{ padding: '8px 0' }}>
                        <div className="w3-text-grey" style={{ fontSize: 12 }}>تاریخ ثبت</div>
                        <div className="w3-text-white">{formatDate(req.created_at)}</div>
                      </div>
                      <div className="w3-col s12" style={{ padding: '8px 0' }}>
                        <div className="w3-text-grey" style={{ fontSize: 12 }}>مشخصات کامل فایل</div>
                        <div className="w3-text-white">{req.description}</div>
                      </div>
                      <div className="w3-col s12 m6" style={{ padding: '8px 0' }}>
                        <div className="w3-text-grey" style={{ fontSize: 12 }}>ایمیل</div>
                        <div className="w3-text-white" style={{ direction: 'ltr', textAlign: 'right' }}>{req.email}</div>
                      </div>
                      <div className="w3-col s12 m6" style={{ padding: '8px 0' }}>
                        <div className="w3-text-grey" style={{ fontSize: 12 }}>شماره تماس</div>
                        <div className="w3-text-white" style={{ direction: 'ltr', textAlign: 'right' }}>{req.phone}</div>
                      </div>
                    </div>

                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                      {req.status !== 'sent' && (
                        <button
                          onClick={() => handleStatusChange(req.id, 'sent')}
                          className="w3-button w3-round"
                          style={{ color: '#4FC3F7', border: '1.5px solid #4FC3F7', backgroundColor: 'transparent', fontSize: 13 }}
                        >
                          <i className="material-icons" style={{ fontSize: 15, verticalAlign: 'middle' }}>send</i> علامت‌گذاری به‌عنوان ارسال‌شده
                        </button>
                      )}
                      {req.status !== 'pending' && (
                        <button
                          onClick={() => handleStatusChange(req.id, 'pending')}
                          className="w3-button w3-round"
                          style={{ color: '#ff9800', border: '1.5px solid #ff9800', backgroundColor: 'transparent', fontSize: 13 }}
                        >
                          <i className="material-icons" style={{ fontSize: 15, verticalAlign: 'middle' }}>hourglass_empty</i> بازگردانی به در انتظار
                        </button>
                      )}
                      {req.status !== 'closed' && (
                        <button
                          onClick={() => handleStatusChange(req.id, 'closed')}
                          className="w3-button w3-round"
                          style={{ color: '#90A4AE', border: '1.5px solid #90A4AE', backgroundColor: 'transparent', fontSize: 13 }}
                        >
                          <i className="material-icons" style={{ fontSize: 15, verticalAlign: 'middle' }}>lock</i> بستن تیکت
                        </button>
                      )}
                      <button
                        onClick={() => setDeleteTarget(req)}
                        className="w3-button w3-round"
                        style={{ color: '#ff0000', border: '1.5px solid #ff0000', backgroundColor: 'transparent', fontSize: 13 }}
                      >
                        <i className="material-icons" style={{ fontSize: 15, verticalAlign: 'middle' }}>delete</i> حذف
                      </button>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>

      {/* صفحه‌بندی */}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginTop: 20 }}>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
            <button
              key={p}
              onClick={() => setPage(p)}
              className="w3-button w3-round"
              style={{
                minWidth: 36,
                backgroundColor: p === page ? '#2980b9' : 'transparent',
                color: 'white',
                border: '1px solid #37474F'
              }}
            >
              {p}
            </button>
          ))}
        </div>
      )}

      {/* تایید حذف */}
      {deleteTarget && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 340, maxWidth: '90%', overflow: 'hidden' }}>
            <div className="w3-container w3-padding" style={{ backgroundColor: '#ff000022', borderBottom: '2px solid #ff0000' }}>
              <h4 className="w3-text-white" style={{ margin: 0 }}>تایید حذف</h4>
            </div>
            <div className="w3-container w3-padding">
              <p className="w3-text-white">آیا از حذف این درخواست مطمئن هستید؟</p>
            </div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16, display: 'flex', gap: 10 }}>
              <button onClick={handleDelete} className="w3-button" style={{ flex: 1, color: 'white', backgroundColor: '#ff0000', borderRadius: 10 }}>
                بله، حذف شود
              </button>
              <button onClick={() => setDeleteTarget(null)} className="w3-button" style={{ flex: 1, color: '#15ff00', border: '2px solid #15ff00', backgroundColor: 'transparent', borderRadius: 10 }}>
                انصراف
              </button>
            </div>
          </div>
        </div>
      )}

      {/* پیام موفقیت/خطا */}
      {toast.show && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 320, maxWidth: '90%', overflow: 'hidden' }}>
            <div
              className="w3-container w3-padding"
              style={{ backgroundColor: toast.type === 'success' ? '#15ff0022' : '#ff000022', borderBottom: `2px solid ${toast.type === 'success' ? '#15ff00' : '#ff0000'}` }}
            >
              <span onClick={() => setToast({ ...toast, show: false })} className="w3-button w3-display-topright" style={{ color: 'white' }}>&times;</span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>{toast.type === 'success' ? '✅ موفقیت' : '❌ خطا'}</h4>
            </div>
            <div className="w3-container w3-padding"><p className="w3-text-white">{toast.message}</p></div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16 }}>
              <button
                onClick={() => setToast({ ...toast, show: false })}
                className="w3-button w3-block"
                style={{ color: toast.type === 'success' ? '#15ff00' : '#ff0000', border: `2px solid ${toast.type === 'success' ? '#15ff00' : '#ff0000'}`, backgroundColor: 'transparent', borderRadius: 10 }}
              >
                باشه
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};